import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation } from "react-router-dom";

import {
  Home,
  LayoutDashboard,
  Calculator,
  Building2,
  X,
} from "lucide-react";

import logo from "@/assets/logos/zenia_stays.svg";

export default function MobileMenu({ open, onClose }) {

  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  const links = [
    { label: "Home", to: "/", icon: Home },
    { label: "Solutions", to: "/solutions", icon: LayoutDashboard },
    { label: "Revenue Calculator", to: "/revenue-calc", icon: Calculator },
    { label: "Browse Stays", to: "/book", icon: Building2 },
  ];

  const isActive = (href) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname.startsWith(href);
  };

  return (
    <AnimatePresence>
      {open && (

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100]"
        >

          {/* OVERLAY */}
          <div
            onClick={onClose}
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
          />

          {/* 🔥 BOTTOM SHEET */}
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            drag="y"
            dragConstraints={{ top: 0, bottom: 0 }}
            onDragEnd={(e, info) => {
              if (info.offset.y > 120) onClose();
            }}
            transition={{ type: "spring", stiffness: 260, damping: 30 }}
            className="
              absolute bottom-0 left-0 right-0
              rounded-t-[28px]
              bg-bg-surface
              border-t border-border-soft
              shadow-2xl
              max-h-[85vh]
              flex flex-col
            "
          >

            {/* HANDLE */}
            <div className="flex justify-center pt-3 pb-2">
              <div className="w-10 h-1.5 rounded-full bg-border-soft" />
            </div>

            {/* HEADER */}
            <div className="flex items-center justify-between px-5 pb-4">

              <img src={logo} className="h-[52px] w-auto object-contain" />

              <button
                onClick={onClose}
                className="w-9 h-9 rounded-xl border border-border-soft flex items-center justify-center text-text-primary"
              >
                <X size={16} />
              </button>

            </div>

            {/* NAV */}
            <div className="px-4 space-y-2">

              {links.map((item, i) => {
                const active = isActive(item.to);
                const Icon = item.icon;

                return (
                  <Link
                    key={i}
                    to={item.to}
                    onClick={onClose}
                    className={`
                      flex items-center gap-3
                      px-4 py-3 rounded-xl
                      text-[15px] font-medium
                      transition-all

                      ${
                        active
                          ? "bg-bg-light border border-border-soft text-text-primary"
                          : "text-text-muted hover:bg-bg-light"
                      }
                    `}
                  >

                    {/* ICON */}
                    <div className={`
                      w-9 h-9 flex items-center justify-center rounded-lg border
                      ${
                        active
                          ? "bg-brand-primary text-white border-brand-primary"
                          : "bg-bg-light text-text-muted border-border-soft"
                      }
                    `}>
                      <Icon size={16} />
                    </div>

                    {item.label}

                  </Link>
                );
              })}

            </div>

            {/* CTA BLOCK */}
            <div className="mt-auto px-4 pt-6 pb-6">

              <Link
                to="/contact"
                onClick={onClose}
                className="
                  w-full flex items-center justify-center gap-2
                  py-3 rounded-pill
                  bg-brand-primary text-white font-semibold
                  active:scale-[0.98]
                "
              >
                Get in touch →
              </Link>

              <p className="text-center text-xs text-text-muted mt-3">
                Takes less than 30 seconds
              </p>

            </div>

          </motion.div>

        </motion.div>
      )}
    </AnimatePresence>
  );
}